let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6NQzF")).then(() => parcelRequire('8sgY9'));